import { useState, useEffect } from 'react';
import CONSTANTS from '../../constants/constants';
import { cloneDeep } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  ClaimsTransformation,
  ValidationTP,
  DisplayClaim,
  OutputClaim,
  Claim,
  CommonTechnicalProfile,
} from '../../xmlParsing/interfaces';

import {
  getClaims,
  getClaimTransformations,
  getOtherProfiles,
  addClaimsList,
  getLatestFiles,
  addUpdateClaimTransformationsList,
  updateTechnicalProfile,
  addTechnicalProfile,
  getSelfAssertedProfiles,
  replaceTechnicalProfile,
} from '../../store';
import { init_NonInteractiveTechnicalProfile } from '../../xmlParsing/initInterfaces';

// const checkExistingTP = (actionData: any) => {
//   console.log('checkExistingTP :', actionData);
//   closeTechnicalProfile({ ...actionData });
// };
const useTPHook = (
  protocolName: string,
  selectedTP: string,
  closeTechnicalProfile: any,
  parentTP: string,
  updateParent: any,
) => {
  const [actionData, setActionData] = useState<any>();
  const [rightData, setRightData] = useState<any>({});
  const [promptCopyIfReq, setPromptCopyIfReq] = useState(true);
  const [validateTPData, setValidateTPData] = useState<any>({});
  const [show, setShow] = useState<string>('');
  const dispatch = useDispatch();
  const claimsList = useSelector(getClaims);
  const latestFiles = useSelector(getLatestFiles);
  const claimsTransformationsList: Record<string, ClaimsTransformation> = useSelector(getClaimTransformations);
  const otherProfiles = useSelector(getOtherProfiles);
  const selfAssertedProfiles = useSelector(getSelfAssertedProfiles);

  useEffect(() => {
    if (selfAssertedProfiles && selectedTP) {
      const _nodeData =
        protocolName === CONSTANTS.PROTOCOL_NAME.selfAssertedProfiles
          ? selfAssertedProfiles[selectedTP]
          : otherProfiles[selectedTP];
      setActionData(_nodeData);
    }
  }, [selectedTP, selfAssertedProfiles, otherProfiles]);

  const onChangeLabel = (e: any) => {
    setActionData({ ...actionData, displayName: e.target.value });
  };

  const onChangeClaimProvider = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setActionData({ ...actionData, claimProvider: e.target.value });
  };

  const validateSelfAssertedProfile = () => {
    let isSuccess = true;
    let displayMsg = '';
    const outputClaims = (actionData.outputClaims || []).reduce(
      (acc: string[], curVal: OutputClaim) => acc.concat([curVal.claimTypeReferenceId]),
      [],
    );

    const vtpList = (actionData[CONSTANTS.VALIDATION_TECHNICAL_PROFILES] || []).reduce(
      (acc: string[], curVal: ValidationTP) => {
        return acc.concat([curVal.id]);
      },
      [],
    );

    vtpList.forEach((vtp: string) => {
      // @ts-ignore
      const vtpoutputClaims: string[] = otherProfiles[vtp][CONSTANTS.OUTPUT_CLAIMS].reduce(
        (acc: string[], curVal: OutputClaim) => acc.concat([curVal.claimTypeReferenceId]),
        [],
      );

      const _vtpClaimIssueList: string[] = vtpoutputClaims.reduce((acc: string[], dc: string) => {
        return !outputClaims.includes(dc) ? acc.concat([dc]) : acc;
      }, []);
      if (_vtpClaimIssueList.length > 0) {
        isSuccess = false;
        displayMsg += `Output claims (${_vtpClaimIssueList}) from the validation technical profile ${vtp} will not be added to the claims bag. \n`;
      }
    });

    if (isSuccess) closeTechnicalProfile({ ...actionData });
    else {
      const resp = window.confirm(
        displayMsg +
          'Add these to the output claims of the technical profile if you would like to access them elsewhere in the user journey.',
      );
      if (resp) closeTechnicalProfile({ ...actionData });
    }
  };

  const checkExistingVTP = (actionData: any, data: any, type: string, mode: string, parentTP: string) => {
    const _latestFiles = cloneDeep(latestFiles).reverse();
    let _res: any = {
      dupVTP: [],
      dupTP: [],
    };
    if (parentTP === '') {
      // TP is coming from orchestration step
      console.log('TP is coming from orchestration step protocolName :', protocolName);
      return _res;
    } else {
      // TP is coming as VTP
      console.log('TP is coming as VTP parentTP :', parentTP);

      _latestFiles.forEach((file: any) => {
        // check Self Asserted Profiles
        Object.keys(file[CONSTANTS.PROTOCOL_NAME.selfAssertedProfiles]).forEach((saProfile: string) => {
          if (
            saProfile !== parentTP &&
            file[CONSTANTS.PROTOCOL_NAME.selfAssertedProfiles][saProfile][CONSTANTS.VALIDATION_TECHNICAL_PROFILES]
              // @ts-ignore
              .reduce((acc, curVal) => acc.concat(curVal['id']), [])
              .includes(actionData['id'])
          ) {
            _res['dupVTP'].push(saProfile);
          }
        });
      });
      return _res;
    }
  };
  const updateParentTP = (data: any) => {
    switch (data.type) {
      case CONSTANTS.VALIDATION_TECHNICAL_PROFILES:
        setRightData({
          ...rightData,
          id: data['newId'],
          selectedTP: data['newId'],
        });
        break;
    }
  };

  const repTechnicalProfile = (tpName: string) => {
    if (tpName === actionData['id']) {
      // update existing
      setPromptCopyIfReq(false);
    } else {
      // create a new copy
      actionData['id'] &&
        dispatch(
          replaceTechnicalProfile({
            data: {
              ...actionData,
              id: tpName,
            },
            protocolName,
            oldId: actionData['id'],
            parentTP: parentTP,
            parentTPType: CONSTANTS.PROTOCOL_NAME.selfAssertedProfiles,
            type: CONSTANTS.VALIDATION_TECHNICAL_PROFILES,
          }),
        );
      updateParent({
        type: CONSTANTS.VALIDATION_TECHNICAL_PROFILES,
        oldId: actionData['id'],
        newId: tpName,
      });
    }

    onCloseRight(validateTPData['actualData']['data'], rightData['type'], rightData['mode'], tpName);
  };

  const checkBeforeUpdate = (data: any, type: string, mode: string) => {
    const res: any = checkExistingVTP(actionData, data, type, mode, parentTP);
    if (
      Object.keys(res).length > 0 &&
      (Object.keys(res['dupVTP']).length > 0 || Object.keys(res['dupTP']).length > 0) &&
      promptCopyIfReq &&
      data !== null
    ) {
      setShow('validateTP');
      setValidateTPData({ validateData: res, actualData: { data, type, mode } });
    } else {
      onCloseRight(data, rightData['type'], rightData['mode'], actionData['id']);
    }
  };

  const onCloseRight = (data: any, type: string, mode: string, selectedTP: string) => {
    if (data !== null) {
      dispatch(
        updateTechnicalProfile({
          data,
          type,
          mode,
          protocolName,
          selectedTP,
        }),
      );

      if (
        [
          CONSTANTS.INPUT_CLAIMS,
          CONSTANTS.OUTPUT_CLAIMS,
          CONSTANTS.DISPLAY_CLAIMS,
          CONSTANTS.PERSISTED_CLAIMS,
        ].includes(type) &&
        mode === 'add'
      ) {
        if (!claimsList.hasOwnProperty(data['ioclaim']['claimTypeReferenceId'])) {
          let _obj: Claim = {
            id: data['ioclaim']['claimTypeReferenceId'],
            displayName: data['claim']['displayName'] || '',
            userInputType: data['claim']['userInputType'] || '',
            dataType: data['claim']['dataType'] || 'string',
            userHelpText: data['claim']['userHelpText'] || '',
            adminHelpText: data['claim']['adminHelpText'] || '',
          };
          if (data['claim'].hasOwnProperty('mask')) {
            _obj['mask'] = data['claim']['mask'];
          }
          if (data['claim'].hasOwnProperty('restriction')) {
            _obj['restriction'] = data['claim']['restriction'];
            if (data['claim']['restriction'] === 'Enumeration') {
              // restriction is Enumeration
              _obj['enumeration'] = data['claim']['enumeration'];
            } else {
              // restriction is Pattern
              _obj['pattern'] = data['claim']['pattern'];
            }
          }
          dispatch(addClaimsList(_obj));
        }
      } else if ([CONSTANTS.INPUT_CLAIMS_TRANSFORMATIONS, CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS].includes(type)) {
        if (mode === 'edit' || (mode === 'add' && !claimsTransformationsList.hasOwnProperty(data['id']))) {
          let obj = {
            id: data['id'],
            inputClaims: data['inputClaims'],
            inputParameters: data['inputParameters'],
            outputClaims: data['outputClaims'],
            transformationmethod: data['transformationmethod'],
          };
          dispatch(addUpdateClaimTransformationsList(obj));
        }
      } else if ([CONSTANTS.VALIDATION_TECHNICAL_PROFILES].includes(type) && mode === 'add') {
        if (!otherProfiles.hasOwnProperty(data['id'])) {
          let obj = init_NonInteractiveTechnicalProfile();
          let protocol = ['', ''];
          let includeTechnicalProfile = '';
          if (data['vtpType'] === 'REST-API') {
            protocol = CONSTANTS.PROTOCOLS['REST-API'];
          } else if (['AAD-Read', 'AAD-Write'].includes(data['vtpType'])) {
            protocol = CONSTANTS.PROTOCOLS.AAD_PROTOCOL;
            includeTechnicalProfile = 'AAD-Common';
          }
          dispatch(
            addTechnicalProfile({
              data: {
                ...obj,
                id: data['id'],
                protocol,
                includeTechnicalProfile,
                // @ts-ignore
                metadata: CONSTANTS.TECHNICAL_PROFILES[data['vtpType']][CONSTANTS.VALIDATION_METADATA],
              },
              protocolName: CONSTANTS.PROTOCOL_NAME.otherProfile,
            }),
          );
        }
      }
    }
    setRightData({});
  };

  return {
    actionData,
    rightData,
    claimsTransformationsList,
    validateTPData,
    show,
    setShow,
    onChangeClaimProvider,
    setRightData,
    onChangeLabel,
    validateSelfAssertedProfile,
    onCloseRight,
    updateParentTP,
    repTechnicalProfile,
    checkBeforeUpdate,
  };
};
export default useTPHook;
